import $ from '@vaersaagod/tools/Dom';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default el => {
    const dom = $(el);
    const icon = dom.find('[data-icon]');
    const wrapper = dom.find('[data-wrapper]').get(0);
    const container = dom.find('[data-icon-container]').get(0);

    let flkty = null;
    let timeout = null;
    let animTimeout = null;

    const restartAnimation = () => {
        clearTimeout(animTimeout);
        icon.removeClass('paused');
    };

    const pauseAnimation = () => {
        clearTimeout(animTimeout);
        icon.addClass('paused');
        animTimeout = setTimeout(restartAnimation, 5000);
    };

    const showIcon = () => {
        restartAnimation();
        TweenLite.to(container, 0.5, { autoAlpha: 1, ease: Sine.easeInOut });
    };

    const hideIcon = () => {
        TweenLite.to(container, 0.5, { autoAlpha: 0, ease: Sine.easeInOut });
    };

    const init = () => {
        flkty = new Flickity(wrapper, {
            freeScroll: true,
            freeScrollFriction: 0.04,
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            cellAlign: 'left',
            imagesLoaded: true
        });
        flkty.resize();

        flkty.on('dragStart', () => {
            hideIcon();
            document.ontouchmove = e => e.preventDefault();
        });
        flkty.on('dragEnd', () => {
            document.ontouchmove = () => true;
        });

        flkty.on('settle', () => {
            clearTimeout(timeout);
            timeout = setTimeout(showIcon, 5000);
        });

        icon.on('animationend', pauseAnimation);
    };

    const destroy = () => {
        flkty.destroy();
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Slider.js